module.exports = __webpack_public_path__ + "static/media/Loader-1.0a25ab26.gif";